import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { SearchService } from '../services/search.service';

@Component({
  standalone: true,
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrl: './search.component.css',
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule
  ]
})
export class SearchComponent {
  @Input() placeholder: string = 'Search...';
  @Input() appearance: 'nav' | 'hero' = 'nav';
  @Input() showButton: boolean = true;
  @Input() embedMode: boolean = false;

  query: string = '';
  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private searchService: SearchService
  ) {
    this.searchService.query$
      .pipe(takeUntil(this.destroy$))
      .subscribe(sharedQuery => {
        if (sharedQuery !== this.query) {
          this.query = sharedQuery;
        }
      });
  }

  onQueryChange(value: string): void {
    this.searchService.setQuery(value);
  }

  onSearch(): void {
    const q = this.query.trim();
    if (q) {
      this.searchService.setQuery(q);
      if (!this.embedMode) {
        this.router.navigate(['/search'], { queryParams: { q } });
      }
    }
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.onSearch();
    }
  }

  clear(): void {
    this.query = '';
    this.searchService.setQuery('');
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
